import { Locale, type LocalizedString } from "../Locale.js";

export const helpLongPartsPathMap = {
	[Locale.cs]: "chci-skladovat-dlouhe-dily" as const,
} satisfies LocalizedString;
